import { Injectable } from '@angular/core';
import { HttpClient,
        HttpHeaders } from '@angular/common/http';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/map';
import { Observable, timer } from 'rxjs';
import { catchError, switchMap, timeout } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { retryRequest } from '../pipes/retry-request.operator';
import { MikrotikConfigurationDto } from '../models';

@Injectable({
    providedIn: 'root'
})
export class GatewayConfigService {

    private static readonly PROBE_INITIAL_TIMEOUT_MS = 3000;
    private static readonly PROBE_RETRY_PAUSE_MS = 3000;
    private static readonly PROBE_RETRY_TIMEOUT_MS = 15000;

    private actionUrl: string = `${environment.gatewayApiURL}/Mikrotik`;
    private httpOptions = {
        headers: new HttpHeaders({
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-Skip-Interceptor': '',
            'X-Keep-Base-Url': ''
        })
        };

    constructor(private http: HttpClient) {}

    //
    // location probe - pull config from connected gateway api
    //
    public getMikrotikConfiguration(): Observable<MikrotikConfigurationDto> {

        const request$ = this.http.get<MikrotikConfigurationDto>(
            `${this.actionUrl}/configuration/`,
            this.httpOptions
        );

        return request$.pipe(
            timeout(GatewayConfigService.PROBE_INITIAL_TIMEOUT_MS),
            catchError(() =>
                timer(GatewayConfigService.PROBE_RETRY_PAUSE_MS).pipe(
                    switchMap(() => request$.pipe(
                        timeout(GatewayConfigService.PROBE_RETRY_TIMEOUT_MS)
                    ))
                )
            )
        );
    }
}